export default "__VITE_ASSET__BtVGyRtO__"